/**
 * Local simulation only. Backend /repack-v3/batches remains the authoritative
 * concurrency-safe check before any Repack work is persisted.
 * Capacity is scoped by purchase_item_id, never just by SKU or work date.
 */
const positiveWholeQty = (value) => {
  const raw = String(value ?? "").trim();
  if (!raw) return 0;
  const qty = Number(raw);
  return Number.isSafeInteger(qty) && qty > 0 ? qty : 0;
};

export function remainingBeforeRepackLine(lines, source, index) {
  if (!source) return null;
  const capacity = Math.max(0, Number(source.remaining_repack_qty) || 0);
  const priorQty = lines.slice(0, index).reduce((sum, line) =>
    line.purchase_item_id === source.purchase_item_id ? sum + positiveWholeQty(line.qty_worked) : sum, 0);
  return Math.max(0, capacity - priorQty);
}

export function buildRepackAllocationRows(lines, sources) {
  const bySource = new Map(sources.map((source) => [source.purchase_item_id, source]));
  const allocated = new Map();
  return lines.map((line) => {
    const source = bySource.get(line.purchase_item_id);
    if (!source) return { availableBefore: null, remainingAfter: null, shortage: 0, invalidQty: false };
    const raw = String(line.qty_worked ?? "").trim();
    const qty = Number(raw);
    const invalidQty = raw !== "" && (!Number.isSafeInteger(qty) || qty <= 0);
    const usableQty = invalidQty ? 0 : positiveWholeQty(raw);
    const capacity = Math.max(0, Number(source.remaining_repack_qty) || 0);
    const usedBefore = allocated.get(source.purchase_item_id) || 0;
    const availableBefore = Math.max(0, capacity - usedBefore);
    const remainingAfter = capacity - usedBefore - usableQty;
    allocated.set(source.purchase_item_id, usedBefore + usableQty);
    return { availableBefore, remainingAfter, shortage: Math.max(0, usableQty - availableBefore), invalidQty };
  });
}
